export default __webpack_public_path__ + "static/media/ac_lh.55d2b0b8.bmp";